<template>
    <el-dialog
    :visible.sync="isOpen"
    :modal-append-to-body="false"
    class="peiso-modal labour-target-container"
    :width="width"
    :before-close="handleClose"
    center>
        <div class="header-container">
            <span>SET LABOUR TARGET</span>
        </div>

        <div class="body-container">
            <span class="d-block title m-bottom-10">Labour Target</span>
            <el-input v-model="labourTarget" type="number" step=".01" class="peiso-input-default">
                <template #suffix>
                    %
                </template>
            </el-input>


            <div class="d-flex justify-content-center w-100 m-top-1-5rem">
                <el-button type="peiso-primary-pink-border-only" @click="setLabourTarget()" :disabled="isLoading">
                    <i v-if="isLoading" class="el-icon-loading"></i>
                    Set Labour Target
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<style lang='scss'>
    .labour-target-container {
        .body-container {
            margin: 0px 0px !important;
            padding: 1rem 0rem !important;
            border: 1px solid transparent !important;
        }
        .el-input__suffix {
            position: absolute;
            top: 18px !important;
            text-align: center;
            right: 5% !important;
        }
        .el-button {
            &--peiso-primary-pink-border-only {
                padding: 1rem 3rem;
                span {
                    font-weight: 700 !important;
                }
            }
        }

        .peiso-input-default {
            .el-input__inner {
                text-align: center;
            }
        }
    }
</style>

<script>
import api from '@/api/api'
    export default {
        data() {
            return {
                isOpen: false,
                labourTarget: null,
                isLoading: false,
            }
        },
        props: {
            open: {
                default: false,
            },
            width: {
                default: '660px'
            }
        },
        watch: {
            open(val) {
                this.isOpen = val
                if (val) {
                    this.showLabourTarget()
                }
            }

        },
        computed: {

        },
        methods: {
            handleClose() {
                this.$emit('close-modal')
            },

            setLabourTarget() {
                this.isLoading = true
                var data = {}
                data.profitTargetType = 1
                data.revenueTargetThreshold = 0
                data.type = 1
                var labourTarget = parseFloat(this.labourTarget) ? parseFloat(this.labourTarget) : 0
                var profitTarget = 0
                profitTarget = 100 - labourTarget.toFixed(2)

                data.profitTarget = profitTarget.toFixed(2) / 100

                api.saveTargetRoster(data, res => {
                    let {code, data, message} = res.data;
                    if(code == 0){
                        this.$router.push({path:'/setting'})
                        this.$emit('close-modal')
                        this.$emit('refresh')
                        this.isLoading = false
                    }else{
                        Utils.alert2('', message, 'error')
                    }
                })
            },

            showLabourTarget() {
                this.isLoading = true
                api.getTargetRoster({}, res => {
                    var result = res.data
                    if (typeof(result.data) ==  'undefined') {
                        return
                    }
                    if (result.code == 0) {
                        if (result.data && result.data.profitTarget >= 100) {
                            this.labourTarget = 0;
                        } else {
                            this.labourTarget = ((1 - result.data.profitTarget) * 100)

                            this.labourTarget = this.labourTarget.toFixed(2);
                        }

                        this.isLoading = false
                    }
                })
            }

        },
        mounted() {
            this.showLabourTarget();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modal/labourTarget.vue